import React from 'react';

// Componente para distribución de montos por área
const AmountDistributionChart = ({ data }) => {
  return (
    <div className="w-full h-full">
      <div className="chart-header">
        <h3 className="chart-title">Distribución por Área</h3>
        <p className="chart-subtitle">Monto total por división</p>
      </div>
      <div className="chart-content">
        <div className="flex items-center justify-center h-64 text-gray-500">
          <div className="text-center">
            <div className="text-4xl mb-2">🍰</div>
            <p>Gráfico de distribución</p>
          </div>
        </div>
      </div>
      <div className="chart-footer">
        <div className="chart-insight">Distribución organizacional</div>
        <div className="chart-metric">Por implementar</div>
      </div>
    </div>
  );
};

export default AmountDistributionChart; 